import { Icon, Icons, ListItem, Tooltip } from '@silverfort/sf-components';
import xExitIcon from '../../../../../components/common/NewImages/x-exit.svg';
import { ReportsMessages, ReportType, ServiceAccountExportOptions } from '../../ServiceAccountsTypes';
import { dateFormat, downloadFile } from '../../../../../components/utils';
import { useEffect } from 'react';
import { ReportManagerMessages } from './ReportManagerMessages';

const ReportItem = ({
    fileCreationDate,
    downloadTitle,
    value,
    isJson,
    generateExport
}: {
    fileCreationDate?: string;
    downloadTitle: string;
    value: ReportType;
    isJson: boolean;
    generateExport: (key: ReportType, isJson: boolean) => Promise<void>;
}) => {
    return (
        <div className="group px-4 py-3 flex justify-between items-center rounded-lg hover:bg-sf-light-100">
            <ListItem
                className="group-hover:bg-sf-light-100"
                titleClassName="font-medium"
                subtitleClassName="font-normal"
                IconLeft={Icons.Document}
                title={downloadTitle}
                subtitle={fileCreationDate && dateFormat(new Date(fileCreationDate))}
                value={value}
            />

            <div className="flex gap-1">
                <Tooltip title="Regenerate" placement={'top'}>
                    <button
                        className="hover:bg-sf-gray-100 p-2 rounded-lg"
                        onClick={() => generateExport(value, isJson)}>
                        <Icon icon={Icons.Refresh} />
                    </button>
                </Tooltip>
                <Tooltip title="Download" placement={'top'}>
                    <button
                        className="hover:bg-sf-gray-100 p-2 rounded-lg"
                        onClick={() => {
                            downloadFile(
                                `/ServiceAccountsV2/downloadServiceAccountsData?fileType=${value}&isJson=${isJson}`
                            );
                        }}>
                        <Icon icon={Icons.Download} />
                    </button>
                </Tooltip>
            </div>
        </div>
    );
};

export const ReportManager = ({
    setShouldShowManager,
    exportOptionsData,
    generateExport,
    managerMessages,
    setManagerMessages,
    refreshExportReportStatus
}: {
    setShouldShowManager: React.Dispatch<React.SetStateAction<boolean>>;
    exportOptionsData: ServiceAccountExportOptions;
    generateExport: (key: ReportType, isJson: boolean) => Promise<void>;
    setManagerMessages: React.Dispatch<React.SetStateAction<ReportsMessages[]>>;
    managerMessages: ReportsMessages[];
    refreshExportReportStatus: () => Promise<void>;
}) => {
    useEffect(() => {
        refreshExportReportStatus();
    }, [refreshExportReportStatus]);

    return (
        <div className="bg-white rounded-lg shadow-sf-large w-120 max-h-[424px] overflow-auto">
            <div className="h-full w-full  flex justify-between border-b border-sf-gray-100 flex-col">
                <div className="flex flex-row items-center w-full py-5 px-4 border-b border-gray-100">
                    <div className="flex-grow font-semibold">Report Manager</div>
                    <button
                        onClick={() => {
                            setShouldShowManager(false);
                        }}
                        className="hover:bg-sf-gray-100 rounded-lg">
                        <img src={xExitIcon} alt="" />
                    </button>
                </div>

                <div className="flex-col w-full flex-grow">
                    <ReportManagerMessages
                        managerMessages={managerMessages}
                        removeMessage={(id: number) => {
                            setManagerMessages((messages) => {
                                return messages.filter((item) => item.id !== id);
                            });
                        }}
                    />
                    <div className="pl-4 pr-3 py-2">
                        {Object.entries(exportOptionsData).map(([optionKey, optionVal], outerIndex) => {
                            const csvFileCreationDate = exportOptionsData[optionKey].csvData?.fileCreationTime;
                            const jsonFileCreationDate = exportOptionsData[optionKey].jsonData?.fileCreationTime;
                            return (
                                <>
                                    <div key={`${csvFileCreationDate}-${outerIndex}CSV`}>
                                        {exportOptionsData[optionKey].csvData?.fileName && (
                                            <ReportItem
                                                fileCreationDate={csvFileCreationDate}
                                                downloadTitle={`${optionVal.reportName} CSV`}
                                                value={optionKey as ReportType}
                                                isJson={false}
                                                generateExport={generateExport}
                                            />
                                        )}
                                    </div>
                                    <div key={`${jsonFileCreationDate}-${outerIndex}JSON`}>
                                        {exportOptionsData[optionKey].jsonData?.fileName && (
                                            <ReportItem
                                                fileCreationDate={jsonFileCreationDate}
                                                downloadTitle={`${optionVal.reportName} JSON`}
                                                value={optionKey as ReportType}
                                                isJson={true}
                                                generateExport={generateExport}
                                            />
                                        )}
                                    </div>
                                </>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};
